import { render, staticRenderFns } from "./DocumentMessageBalloon.vue?vue&type=template&id=bd364ff2&scoped=true&"
import script from "./DocumentMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./DocumentMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMessageBalloon.vue?vue&type=style&index=0&id=bd364ff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd364ff2",
  null
  
)

export default component.exports